"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BrowseMatchingSubDialogModule = /** @class */ (function () {
    function BrowseMatchingSubDialogModule() {
    }
    return BrowseMatchingSubDialogModule;
}());
exports.BrowseMatchingSubDialogModule = BrowseMatchingSubDialogModule;
